const defaultState = {
  placements: [{ label: 'Todos', value: 'all' }],
  placementSelected: 'all',
}

export default defaultState
